// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3VO2N","left":"styles_left__1XTzh","desktopActions":"styles_desktopActions__k3nHu","title":"styles_title__3fBSP"};